import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import Points from 'Components/Sections/WhyChooseEmajinGolf/Points'
import { Button, Column } from 'Components/UI'

import { LANDING_CONTENT_PX, LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import Gallery from './Gallery'

type Props = {
  secondary?: boolean
  onAction?: () => void
}

function WhyChooseEmajinGolfSection({ secondary, onAction }: Props) {
  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Column
          alignCenter
          gap={11}
          maxWidth={LANDING_CONTENT_WIDTH_PX}
          pb={secondary ? 80 : 0}
          pt={80}
          px={LANDING_CONTENT_PX}
        >
          <SubsectionTitle
            centered
            subtitle="Where golf, business & community combine."
            title="Why Choose Emajin Golf"
          />

          <Gallery />

          <Button large onClick={onAction}>
            Join Us Today
          </Button>

          {!secondary && <Points />}
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default WhyChooseEmajinGolfSection
